<!--
//================================================================================
// ID:BC058P
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC058P
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2022/11/15 | 富士通Japan株式会社    | 新規作成
// 01.01.00 | 2023/04/26 | 富士通Japan株式会社    | 令和5年度改修対応（1次リリース）
// 01.02.00 | 2023/08/08 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
// 01.03.00 | 2024/09/20 | 富士通Japan株式会社    | 令和6年度改修対応（1次リリース）
//================================================================================
-->
<template>
	<main class="contents__main">
		<div>
			<transition :name="fade" mode="out-in">
				<!-- viewPageの値に応じてコンポーネントを切り替え -->
				<component
						:is="viewPage"
						:form="form"
						:sourceInfo="sourceInfo"
						@back="back"
						@addNyukyosya="addNyukyosya"
						@deleteNyukyosya="deleteNyukyosya"
						@addFuyosya="addFuyosya"
						@deleteFuyosya="deleteFuyosya"
						@clacAmount="clacAmount"
						@dataChanged="dataChanged"
				>
				</component>
			</transition>
		</div>
	</main>
</template>

<script>

import BC058Page1 from './BC058C1.vue'
import BC058Page2 from './BC058C2.vue'
import BC058Page3 from './BC058C3.vue'

import { co_isEmpty, co_checkHalfNumber } from '@/common/checkUtility';
import { co_getBrowser, co_getOperation } from '@/common/browserUtility.js'; 
import { co_clearParam, co_toTransCtrl } from '@/common/screenUtility.js';

import { STORE_DATA_GETDATA, STORE_ENV_GET_TOKUBETUKOJO_ROJIN, STORE_ENV_GET_TOKUBETUKOJO_TOKUTEI,
			STORE_ENV_GET_TOKUBETUKOJO_SYOGAI, STORE_ENV_GET_TOKUBETUKOJO_TOKSYOGAI, STORE_ENV_GET_TOKUBETUKOJO_KAFU,
			STORE_ENV_GET_TOKUBETUKOJO_HITORIOYA, STORE_VIEW_GET_PARAMS } from '@/const/store.js';

export default {
	data: function () {
		return {
			form: {
				zyutakuInfo: [],		// 住宅情報
				kbBosyu: '',			// 募集の種類
				ymBosyu: '',			// 募集年月
				noRenzoku: '',			// 連番
				noUketuke: '',			// 受付番号
				dtSyokaiMosikomi: '',	// 初回申込日
				dtMosikomi: '',			// 申込日
				nmBosyu: '',			// 募集の種類名
				kbZyutaku: '',			// 住宅の種別
				nmZyutaku: '',			// 住宅の種別名
				kbKoubo: '',			// 公募区分
				noMouchiku: '',			// 申込地区番号
				nuDoukyo: '',			// 同居人数
				nuNyukyo: '',			// 入居人数
				kbMosikomi: '',			// 申込区分
				nmMosikomi: '',			// 申込区分名
				cdYugu: '',				// 優遇コード
				nmYugu: '',				// 優遇コード名
				idRiyosya: '',			// 利用者番号
				nmMouname1: '',			// 申込者（氏）
				nmMouname2: '',			// 申込者（名）
				nmMoukana1: '',			// 申込者フリガナ（氏）
				nmMoukana2: '',			// 申込者フリガナ（名）
				nmMoutusyoname1: '',	// 申込者通称名（氏）
				nmMoutusyoname2: '',	// 申込者通称名（名）
				nmMoutusyokana1: '',	// 申込者通称名フリガナ（氏）
				nmMoutusyokana2: '',	// 申込者通称名フリガナ（名）
				dtMoubirthday: '',		// 申込者生年月日
				noMouzip1: '',			// 申込者郵便番号１
				noMouzip2: '',			// 申込者郵便番号２
				txMouadr1: '',			// 申込者現住所１
				txMouadr2: '',			// 申込者現住所２
				txMouadr3: '',			// 申込者現住所３
				idMoutel1: '',			// 申込者電話番号（市外）
				idMoutel2: '',			// 申込者電話番号（市内）
				idMoutel3: '',			// 申込者電話番号（局番）
				nuKyojyu: '',			// 申込者居住年数
				kbZairyusikaku: '',		// 申込者在留資格
				dtZairyuStt: '',		// 申込者在留期間（自）
				dtZairyuEnd: '',		// 申込者在留期間（至）
				moAllsyotoku: '',		// 年間所得金額合計
				moAlltokubetu: '',		// 特別控除金額
				moAllsasihiki: '',		// 差引所得金額
				nuKazoku: 0,			// 家族人数
				cdNowjyutaku: '',		// 現在の住宅の種類
				moNowyachin: '',		// 現在の住宅の家賃
				cdNowmadori: '',		// 現在の住宅の間取り
				nuNowtatamisu: '',		// 現在の住宅の畳数
				nuNowsenyo: '',			// 現在の住戸専用面積
				kbKaidan: '',			// 階段困難区分
				kbSyoyu: '',			// 住宅土地所有区分
				fgSeiyakuDoui: '',		// 誓約・同意の有無
				cdStatus: '',			// 状況
				txOstype: '',			// OSの種類
				txOsversion: '',		// OSのバージョン
				txBrowsertype: '',		// ブラウザの種類
				txAnketo1: '',			// アンケート表題１
				kbAnketo1: '',			// アンケート回答１
				txAnketo1ansetc: '',	// アンケート回答１その他
				txAnketo2: '',			// アンケート表題２
				kbAnketo2: '',			// アンケート回答２
				txAnketo2ansetc: '',	// アンケート回答２その他
				txAnketo3: '',			// アンケート表題３
				kbAnketo3: '',			// アンケート回答３
				txAnketo3ansetc: '',	// アンケート回答３その他
				txAnketo4: '',			// アンケート表題４
				txAnketo4ans: '',		// アンケート回答４
				nyukyoList: [],			// 入居者情報リスト
				fuyoList: [],			// 遠隔地扶養者情報リスト
				mouItems1cdHanyo2: '',	// 申込区分注意文１汎用コード２
				transKbn: '',			// 遷移区分
				dtBosyuStt: '',			// 募集開始日
				dtYusouEnd: '',			// 郵送締切日
				mosikomiLinkItems: [],	// 申込区分注意文のリンク先
				nuFuyo: 20,				// 遠隔地扶養者人数
				nuBekkyo: 4,			// 別居予定者人数
				kbBekkyoyotei: '',		// 別居予定者有無区分
				txBekkyozyokyo: '',		// 別居状況内容
				txKiboJyoken: '',		// ご希望の住宅の条件
				dtHozon: '',			// 保存期間日時
				bosyuHoshiki: '4',		// 募集方式（1：毎月募集、2：定期募集（抽選方式）、3：定期募集（ポイント方式）、4：随時募集）
				seinensyaAge: 20,		// 成年者基準年齢
				moSyotoku: '',			// 申込者年間所得金額
				fgKojto: '',			// 申込者特別控除
				txSyozaichi: '',		// 申込者所在地
				txName: '',				// 申込者名称
				idTel1: '',				// 申込者電話番号（市外）
				idTel2: '',				// 申込者電話番号（市内）
				idTel3: '',				// 申込者電話番号（局番）
				dtYmdStt: '',			// 申込者勤務（開業）開始日
				cdSyokugyo: '',			// 申込者職業
				fgTokubetu: '',			// 特別区分
				kbShinGaitokomoku: '',	// 心身障害者該当項目
				syotokuErrUrlList: [],	// 所得金額超過エラーURLリスト
			},
			sourceInfo: {
				selectNo: 0,			// 選択行No
				transKbn: '',			// 遷移区分（サブ画面用）
			},
			transKbn: '',				// 遷移区分
			jyutakuInfo: [],			// 住宅情報
			mosikomiInfo: [],			// 申込情報
			noRenzoku: ''				// 連番
		}
	},
	created: async function() {

		// パラメタ設定
		this.paramSetting();

		// ブラウザ設定
		let os = await co_getOperation();
		let osInfo = os.split(',');
		this.form.txOstype = osInfo[0];				// OSの種類
		this.form.txOsversion = osInfo[1];			// OSのバージョン
		this.form.txBrowsertype = co_getBrowser();	// ブラウザの種類

	},
	computed: {
		viewPage () {
			// URLのhashの値に基づいて、返すコンポーネントを切り替え
			switch (this.$route.hash) {
				case '#BC058C2':
					return BC058Page2
				case '#BC058C3':
					return BC058Page3
				default:
					return BC058Page1
			}
		}
	},
	methods: {
		// 遷移元画面からのパラメタ設定
		paramSetting: function() {

			// 前画面からのパラメータを設定
			let params = this.$store.getters[STORE_VIEW_GET_PARAMS]('BC058');
			this.transKbn = params.transKbn;
			this.jyutakuInfo = params.jyutakuInfo;
			this.mosikomiInfo = params.mosikomiInfo;
			this.noRenzoku = params.noRenzoku;

			// 画面間パラメータを削除
			co_clearParam('BC058');

			// 住宅情報設定
			let zyutakuInfo = this.jyutakuInfo;
			if (this.transKbn == '2' || this.transKbn == '3') {
				this.form.transKbn = this.transKbn;
				this.form.noRenzoku = this.noRenzoku;

				if (typeof this.mosikomiInfo.transKbn === 'undefined') {
					// 申込み内容確認画面からの遷移
					this.form.noRenzoku			=	this.mosikomiInfo.noRenzoku;
					this.form.noUketuke			=	this.mosikomiInfo.noUketuke;
					this.form.dtSyokaiMosikomi	=	this.mosikomiInfo.dtSyokaiMosikomi;
					this.form.dtMosikomi		=	this.mosikomiInfo.dtMosikomi;
					this.form.nuDoukyo			=	this.mosikomiInfo.nuDoukyo;
					this.form.nuNyukyo			=	this.mosikomiInfo.nuNyukyo;
					this.form.kbMosikomi		=	this.mosikomiInfo.kbMosikomi;
					this.form.nmMosikomi		=	this.mosikomiInfo.nmMosikomi;
					this.form.nmMouname1		=	this.mosikomiInfo.nmMouname1;
					this.form.nmMouname2		=	this.mosikomiInfo.nmMouname2;
					this.form.nmMoukana1		=	this.mosikomiInfo.nmMoukana1;
					this.form.nmMoukana2		=	this.mosikomiInfo.nmMoukana2;
					this.form.nmMoutusyoname1	=	this.mosikomiInfo.nmMoutusyoname1;
					this.form.nmMoutusyoname2	=	this.mosikomiInfo.nmMoutusyoname2;
					this.form.nmMoutusyokana1	=	this.mosikomiInfo.nmMoutusyokana1;
					this.form.nmMoutusyokana2	=	this.mosikomiInfo.nmMoutusyokana2;
					this.form.dtMoubirthday		=	this.mosikomiInfo.dtMoubirthday;
					this.form.noMouzip1			=	this.mosikomiInfo.noMouzip1;
					this.form.noMouzip2			=	this.mosikomiInfo.noMouzip2;
					this.form.txMouadr1			=	this.mosikomiInfo.txMouadr1;
					this.form.txMouadr2			=	this.mosikomiInfo.txMouadr2;
					this.form.txMouadr3			=	this.mosikomiInfo.txMouadr3;
					this.form.idMoutel1			=	this.mosikomiInfo.idMoutel1;
					this.form.idMoutel2			=	this.mosikomiInfo.idMoutel2;
					this.form.idMoutel3			=	this.mosikomiInfo.idMoutel3;
					this.form.nuKyojyu			=	this.mosikomiInfo.nuKyojyu;
					this.form.kbZairyusikaku	=	this.mosikomiInfo.kbZairyusikaku;
					this.form.dtZairyuStt		=	this.mosikomiInfo.dtZairyuStt;
					this.form.dtZairyuEnd		=	this.mosikomiInfo.dtZairyuEnd;
					this.form.moAllsyotoku		=	this.mosikomiInfo.moAllsyotoku;
					this.form.moAlltokubetu		=	this.mosikomiInfo.moAlltokubetu;
					this.form.moAllsasihiki		=	this.mosikomiInfo.moAllsasihiki;
					this.form.cdNowjyutaku		=	this.mosikomiInfo.cdNowjyutaku;
					this.form.moNowyachin		=	this.mosikomiInfo.moNowyachin;
					this.form.cdNowmadori		=	this.mosikomiInfo.cdNowmadori;
					this.form.nuNowtatamisu		=	this.mosikomiInfo.nuNowtatamisu;
					this.form.nuNowsenyo		=	this.mosikomiInfo.nuNowsenyo;
					this.form.kbKaidan			=	this.mosikomiInfo.kbKaidan;
					this.form.kbSyoyu			=	this.mosikomiInfo.kbSyoyu;
					if (this.mosikomiInfo.fgSeiyakuDoui == '1') {
						this.form.fgSeiyakuDoui		=	this.mosikomiInfo.fgSeiyakuDoui;
					}
					this.form.cdStatus			=	this.mosikomiInfo.cdStatus;
					this.form.nyukyoList		=	this.mosikomiInfo.nyukyoList;
					this.form.fuyoList			=	this.mosikomiInfo.fuyoList;
					this.form.bekkyoList		=	this.mosikomiInfo.bekkyoList;
					this.form.kbZyutaku			=	this.mosikomiInfo.kbZyutaku;
					this.form.kbBekkyoyotei		=	this.mosikomiInfo.kbBekkyoyotei;
					this.form.txBekkyozyokyo	=	this.mosikomiInfo.txBekkyozyokyo;
					this.form.txKiboJyoken		=	this.mosikomiInfo.txKiboJyoken;
					this.form.noMouchiku		=	this.mosikomiInfo.noMouchiku;
					this.form.moSyotoku			=	this.mosikomiInfo.moSyotoku;
					this.form.fgKojto			=	this.mosikomiInfo.fgKojto;
					this.form.txSyozaichi		=	this.mosikomiInfo.txSyozaichi;
					this.form.txName			=	this.mosikomiInfo.txName;
					this.form.idTel1			=	this.mosikomiInfo.idTel1;
					this.form.idTel2			=	this.mosikomiInfo.idTel2;
					this.form.idTel3			=	this.mosikomiInfo.idTel3;
					this.form.dtYmdStt			=	this.mosikomiInfo.dtYmdStt;
					this.form.cdSyokugyo		=	this.mosikomiInfo.cdSyokugyo;
					let tokubetuList = new Array();
					tokubetuList.push(this.mosikomiInfo.fgTokubetu1 == '1' ? '1' : '');
					tokubetuList.push(this.mosikomiInfo.fgTokubetu2 == '1' ? '2' : '');
					tokubetuList.push(this.mosikomiInfo.fgTokubetu3 == '1' ? '3' : '');
					this.form.fgTokubetu		=	this.co_editListToComma(tokubetuList);
					let shinshinList = new Array();
					shinshinList.push(this.mosikomiInfo.kbShinGaitokomoku1);
					shinshinList.push(this.mosikomiInfo.kbShinGaitokomoku2);
					shinshinList.push(this.mosikomiInfo.kbShinGaitokomoku3);
					shinshinList.push(this.mosikomiInfo.kbShinGaitokomoku4);
					this.form.kbShinGaitokomoku	= this.co_editListToComma(shinshinList);

					// 同居者リストのチェック結果を設定
					for (let i = 0; i < this.form.nyukyoList.length; i++) {
						this.form.nyukyoList[i].isInputCheck = true;
					}

					// 遠隔地扶養者リストのチェック結果を設定
					for (let i = 0; i < this.form.fuyoList.length; i++) {
						this.form.fuyoList[i].isInputCheck = true;
					}

					// 住宅情報設定
					this.form.zyutakuInfo	=	zyutakuInfo;
					this.form.kbBosyu		=	this.form.zyutakuInfo.bosyuKind;
					this.form.ymBosyu		=	this.form.zyutakuInfo.ymBosyu;
					this.form.nmBosyu		=	this.form.zyutakuInfo.nmBosyu;
					this.form.nmZyutaku		=	this.form.zyutakuInfo.nmZyutaku;
					this.form.noRenzoku		=	this.noRenzoku;

				} else {
					// 申込み内容の確認画面からの遷移
					this.form = this.mosikomiInfo;
				}

			} else {

				if (this.mosikomiInfo  == null || this.mosikomiInfo.transKbn == '') {

					// 住宅情報設定
					this.form.zyutakuInfo	=	zyutakuInfo;
					this.form.kbBosyu		=	this.form.zyutakuInfo.bosyuKind;
					this.form.nmBosyu		=	this.form.zyutakuInfo.nmBosyu;
					this.form.kbZyutaku		=	this.form.zyutakuInfo.jyutakuKind;
					this.form.nmZyutaku		=	this.form.zyutakuInfo.nmZyutaku;
					this.form.ymBosyu		=	this.form.zyutakuInfo.ymBosyu;
					this.form.noMouchiku	=	this.form.zyutakuInfo.noMouchiku;
					this.form.noRenzoku		=	this.noRenzoku;
					// this.transKbn			=	'1';
					this.form.transKbn		=	this.transKbn;

					// 状態管理（ストア）から募集住宅検索情報を取得
					let data = this.$store.getters[STORE_DATA_GETDATA]('BC055');
					this.form.nuNyukyo		=	data.nyukyoNinzu;

				} else {
					// 申込み内容の確認画面からの遷移
					this.form = this.mosikomiInfo;
				}
			}

			// 募集方式：随時募集
			this.form.bosyuHoshiki = '4';

		},
		// サブ画面から世帯情報入力画面へ遷移
		back: function(select) {
			this.transitionName = 'slide-back'
			this.sourceInfo.selectNo = select - 1;
			switch (this.$route.hash) {
				case '#BC058C2':
					this.sourceInfo.transKbn = '2';
					break;
				case '#BC058C3':
					this.sourceInfo.transKbn = '3';
					break;
			}
			this.$router.push({ hash: '#BC058C1'})
			co_toTransCtrl();
		},
		// 同居者リスト新規行追加
		addNyukyosya: function(noNyukyo) {
			this.form.nyukyoList.push({
						noNyukyo: noNyukyo,
						nmName1: '',					// 利用者氏名（氏）
						nmName2: '',					// 利用者氏名（名）
						nmKana1: '',					// フリガナ（氏）
						nmKana2: '',					// フリガナ（名）
						cdTudukigara: '',				// 続柄
						nmTudukigara: '',				// 続柄（名称）
						dtBirthday: '',					// 生年月日
						kbGender: '', 					// 性別
						nmGender: '', 					// 性別（名称）
						moSyotoku: '',					// 年間所得
						fgKojto: '',					// 特別控除
						nmKojto: '',					// 特別控除（名称）
						kbBekkyo: '',					// 別居予定有無
						cdBekkyoJyutaku: '', 			// 別居住宅の種類
						nmBekkyoJyutaku: '', 			// 別居住宅の種類（名称）
						txNyukyoRiyu: '',				// 都営住宅に入居する理由
						txSyozaichi: '',				// 所在地
						txName: '',						// 名称
						idTel1: '',						// 電話番号（市外）
						idTel2: '',						// 電話番号（市内）
						idTel3: '',						// 電話番号（局番）
						dtYmdStt: '',					// 勤務（開業）開始日
						cdSyokugyo: '',					// 職業
						nmSyokugyo: '',					// 職業（名称）
						isInputCheck: false,			// 入力チェック結果
						viewFlg: false,					// 画面表示フラグ
			});
		},
		// 同居者リスト指定行削除
		deleteNyukyosya: function(noNyukyo) {
			// 指定行削除
			this.form.nyukyoList.splice(noNyukyo - 1, 1);

			// 入居者番号振り直し
			for (let i = 0; i < this.form.nyukyoList.length; i++) {
				this.form.nyukyoList[i].noNyukyo = i + 1;
			}

			if (this.form.nyukyoList.length == 0
				|| (this.form.nyukyoList.length < Number(this.form.nuNyukyo-1)
				&& this.form.nyukyoList[this.form.nyukyoList.length-1].isInputCheck)) {
					// 入居人数と同居者一覧が一致しない かつ 同居者一覧の最終行が入力済みの場合
					// 末尾に新規行を１件追加
					this.addNyukyosya(this.form.nyukyoList.length + 1);
			}

			// 金額計算
			this.clacAmount();
			
		},
		// 遠隔地扶養者リスト新規行追加
		addFuyosya: function(noFuyo) {
			this.form.fuyoList.push({
						noFuyo: noFuyo,
						nmFuyoName1: '',		// 遠隔地扶養者氏名（氏）
						nmFuyoName2: '',		// 遠隔地扶養者氏名（名）
						nmFuyoKana1: '',		// 遠隔地扶養者フリガナ（氏）
						nmFuyoKana2: '',		// 遠隔地扶養者フリガナ（名）
						cdMoukankei: '',		// 申込者との関係
						nmMoukankei: '',		// 申込者との関係（名称）
						dtBirthday: '',			// 生年月日
						moSyotoku: '',			// 年間所得
						fgKojto: '',			// 特別控除
						nmKojto: '',			// 特別控除（名称）
						isInputCheck: false,	// 入力チェック結果
						viewFlg: false,			// 画面表示フラグ
			});
		},
		// 遠隔地扶養者リスト指定行削除
		deleteFuyosya: function(noFuyo) {
			// 指定行削除
			this.form.fuyoList.splice(noFuyo - 1, 1);

			// 遠隔地扶養者番号振り直し
			for (let i = 0; i < this.form.fuyoList.length; i++) {
				this.form.fuyoList[i].noFuyo = i + 1;
			}

			// 遠隔地扶養者一覧の最終行が入力済みの場合
			if (this.form.fuyoList[this.form.fuyoList.length-1].isInputCheck) {
					
				// 末尾に新規行を１件追加
				this.addFuyosya(this.form.fuyoList.length + 1);
			}
			
			// 金額計算
			this.clacAmount();
		},
		// 金額計算
		clacAmount: function() {
			let moAllsyotoku = 0;
			if (!co_isEmpty(this.form.moSyotoku) && co_checkHalfNumber(String(this.form.moSyotoku))) {
				moAllsyotoku = Number(this.form.moSyotoku);
			}
			let moAlltokubetu = 0;
			let maxKingaku = 99999999;
			let sasihikiKojyo = 0;

			if (!co_isEmpty(this.form.fgKojto)) {

				sasihikiKojyo = Number(this.form.moSyotoku);
				let moKojyoList = this.form.fgKojto.split(',');
				for (let n = 0; n < moKojyoList.length; n++) {

					switch (moKojyoList[n]) {
						case '1':	// 特別控除 老人扶養
							moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_ROJIN];
							break;
						case '2':	// 特別控除 特定扶養
							moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_TOKUTEI];
							break;
						case '3':	// 特別控除 障害者
							moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_SYOGAI];
							break;
						case '4':	// 特別控除 特別障害者
							moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_TOKSYOGAI];
							break;
						case '5':	// 特別控除 寡婦
							if (sasihikiKojyo < this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_KAFU]) {
								moAlltokubetu += sasihikiKojyo;
								sasihikiKojyo -= sasihikiKojyo;
								
							} else {
								moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_KAFU];
								sasihikiKojyo -= this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_KAFU];
							}
							break;
						case '6':	// 特別控除 ひとり親
							if (sasihikiKojyo < this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_HITORIOYA]) {
								moAlltokubetu += sasihikiKojyo;
								sasihikiKojyo -= sasihikiKojyo;
							} else {
								moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_HITORIOYA];
								sasihikiKojyo -= this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_HITORIOYA];
							}
							break;
					}
				}
			}
			// 同居者一覧
			for (let i = 0; i < this.form.nyukyoList.length; i++) {
				if (this.form.nyukyoList[i].isInputCheck) {
					// 年間所得金額合計集計
					moAllsyotoku += Number(this.form.nyukyoList[i].moSyotoku);

					// 特別控除金額集計
					if (!co_isEmpty(this.form.nyukyoList[i].fgKojto)) {
						sasihikiKojyo = Number(this.form.nyukyoList[i].moSyotoku);
						// 特別控除を選択している場合
						let kojyoList = this.form.nyukyoList[i].fgKojto.split(',');
						for (let j = 0; j < kojyoList.length; j++) {

							switch (kojyoList[j]) {
								case '1':	// 特別控除 老人扶養
									moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_ROJIN];
									break;
								case '2':	// 特別控除 特定扶養
									moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_TOKUTEI];
									break;
								case '3':	// 特別控除 障害者
									moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_SYOGAI];
									break;
								case '4':	// 特別控除 特別障害者
									moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_TOKSYOGAI];
									break;
								case '5':	// 特別控除 寡婦
									if (sasihikiKojyo < this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_KAFU]) {
										moAlltokubetu += sasihikiKojyo;
										sasihikiKojyo -= sasihikiKojyo;
										
									} else {
										moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_KAFU];
										sasihikiKojyo -= this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_KAFU];
									}
									break;
								case '6':	// 特別控除 ひとり親
									if (sasihikiKojyo < this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_HITORIOYA]) {
										moAlltokubetu += sasihikiKojyo;
										sasihikiKojyo -= sasihikiKojyo;
									} else {
										moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_HITORIOYA];
										sasihikiKojyo -= this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_HITORIOYA];
									}
									break;
							}
						}
					}
				}
			}
			// 遠隔地扶養者一覧
			for (let i = 0; i < this.form.fuyoList.length; i++) {
				if (this.form.fuyoList[i].isInputCheck) {

					// 特別控除金額集計
					if (!co_isEmpty(this.form.fuyoList[i].fgKojto)) {
						// 特別控除を選択している場合
						let kojyoList = this.form.fuyoList[i].fgKojto.split(',');
						for (let j = 0; j < kojyoList.length; j++) {

							switch (kojyoList[j]) {
								case '1':	// 特別控除 老人扶養
									moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_ROJIN];
									break;
								case '2':	// 特別控除 特定扶養
									moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_TOKUTEI];
									break;
								case '3':	// 特別控除 障害者
									moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_SYOGAI];
									break;
								case '4':	// 特別控除 特別障害者
									moAlltokubetu += this.$store.getters[STORE_ENV_GET_TOKUBETUKOJO_TOKSYOGAI];
									break;
							}
						}
					}
				}
			}

			// 金額が「99,999,999円」を超える場合、「99,999,999円」を設定
			// 年間所得金額合計
			if (moAllsyotoku > maxKingaku) {
				moAllsyotoku = maxKingaku;
			}
			// 特別控除金額
			if (moAlltokubetu > maxKingaku) {
				moAlltokubetu = maxKingaku;
			}

			// 年間所得金額合計
			this.form.moAllsyotoku = moAllsyotoku;
			// 特別控除金額
			this.form.moAlltokubetu = moAlltokubetu;
			// 差引所得金額
			let moAllsasihiki = moAllsyotoku - moAlltokubetu;
			if (moAllsasihiki < 0) {
				// 差引所得金額がマイナスの場合
				moAllsasihiki = 0;
			}
			this.form.moAllsasihiki = moAllsasihiki;

		},
		// リスト編集
		co_editListToComma(list) {
			let result = '';
			for (let i = 0; i < list.length; i++) {
				if (i == list.length - 1) {
					result += list[i];
				} else {
					result += list[i] + ',';
				}
			}
			return result;
		},
		// 子画面でのデータ変更受け取り
		dataChanged: function(data) {
			this.form = data;
		}
	}
}
</script>